import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { Button, Hamburger, Icon } from '../../components';
import { APP_ROUTES } from '../../routing/ROUTES';
import { pageUrl } from '../../settings';
import colors from '../../utils/colors';
import { myAccount } from '../../utils/operon';
import './style.scss';
import Tab from './Tab';

function Navbar({ isHamburgerOpen, toggleHamburger }) {
	const location = useLocation();
	const history = useHistory();
	const mobileActive = useSelector((state) => state.filter.mobileActive);

	const activeTab = APP_ROUTES.find((r) => r.path === location.pathname);

	const handleTabChange = (r) => {
		if (r.id === activeTab?.id) return;
		history.push(r.path);
	};

	const handleClickLogout = () => {
		history.push('/logout');
	};

	const tabs = APP_ROUTES?.filter((r) => r.order > 0)?.sort((a, b) => a.order - b.order);

	const parsedTitle = useMemo(
		() => (mobileActive ? 'Filtruj zadania' : activeTab?.label),
		[mobileActive, activeTab]
	);

	return (
		<div className="navbar-wrapper">
			<div className="container">
				<div className="logo">
					<a href={pageUrl} className="logo-desktop">
						<Icon name="logo" color={colors.green} height="30px" width="115px" />
					</a>
					<a href={pageUrl} className="logo-mobile">
						<Icon name="mobile-logo" height="20px" />
					</a>
					<span className="title">Generator testów</span>
				</div>
				<nav className={`navbar-navigation active-tab-${activeTab?.order}`}>
					{tabs?.map((r) => (
						<Tab
							key={r.id}
							id={r.id}
							active={r.id === activeTab?.id}
							color="transparent text-primary"
							onClick={() => handleTabChange(r)}
							title={r.label}
						/>
					))}
				</nav>
				<div className="account">
					<Button color="transparent text-primary" onClick={myAccount}>
						<Icon name="user" width="16" height="16" />
						Moje konto
					</Button>
					<Button color="transparent text-primary" onClick={handleClickLogout}>
						<Icon name="logout" width="16" height="16" />
						Wyloguj się
					</Button>
				</div>
				<div className="navbar-mobile">
					<h2 className="navbar-mobile-title">{parsedTitle}</h2>
					<Hamburger active={isHamburgerOpen} toggle={toggleHamburger} />
				</div>
			</div>
		</div>
	);
}

export default Navbar;
